<script setup>
import ModalWrapper from '@/modals/ModalWrapper';
// import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';
import { ref, watch } from 'vue';

const toast = useToast();
const { shareWith } = useUserStore();
const { all, profile } = storeToRefs(useUserStore());
const props = defineProps({
    kaleadical: {
        type: Object,
        default: () => ({
            thumbnail: '',
            name: '',
            description: '',
            habits: [],
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});
const userProfile = ref(null);

watch(() => profile.value, () => {
    userProfile.value = profile.value;
});

const emit = defineEmits(['close-modal']);

const shareWithUser = async (item) => {
    try {
        const action =  shareWith;
        const toastMessage = 'Kalendical shared successfully';

        await action({
            user_id: item.id,
            hash: props.kaleadical.hash,
        });

        toast.success(toastMessage);
        emit('close-modal');
    } catch (error) {
        toast.error('An unexpected error occurred');
    }
};
</script>
<template>
<ModalWrapper fullscreen>
    <template #header>{{ $t('label.users') }}</template>

    <div class="flex justify-center flex-col items-center pb-2">

        <h2>{{ kaleadical.name }}</h2>

    </div>
    
    <DataTable
        v-if="all"
        :data="all"
        :headers="[
            { title: $t('label.name'), key: 'full_name', value: item => `${item.first_name} ${item.last_name}`, sortable: false },
            { title: $t('label.email'), key: 'email', value: item => item.email, sortable: false },
            { title: $t('label.type'), key: 'type', value: item => item.roles.length ? item.roles[0].display_name : '', sortable: false},
            { title: $t('label.status'), key: 'status', value: item => item.is_active ? $t('label.active') : $t('label.inactive'), sortable: false },
        ]"
        :actions="[
            { title: 'Share', icon: 'share', action: (item) => shareWithUser(item) },
        ]"
        @table-update="tableUpdate" />

    <template #footer>
        <StyledSaveButton modal @save="save" />
    </template>
</ModalWrapper>
</template>
